// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__I6uFu","text":"Banner_text__lbQpE","button":"Banner_button__RknLE","animatedDiv":"Banner_animatedDiv__JxByK"};